import React, { useState, useEffect } from 'react';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';

import api from './../../service/api';
import { formatCurrency } from '../../service/format';
import { getAuthData, isAdmin } from '../../service/auth';

import styles from './styles.module.css';

export default function Payment() {
    var startDate = new Date();
    var endDate = new Date();

    startDate.setDate(1);
    endDate.setMonth(endDate.getMonth() + 1);
    endDate.setDate(0);

    let emptyFilter = {
        startDate: startDate,
        endDate: endDate,
        driver: 'all',
        truck: 'all'
    }
    
   
    const [loading, setLoading] = useState(false);
    const [trucks, setTrucks] = useState([]);
    const [drivers, setDrivers] = useState([]);
    const [filter, setFilter] = useState(emptyFilter);

    const [totalFreight, setTotalFreight] = useState(0);
    const [totalCommission, setTotalCommission] = useState(0);
    const [totalVoucher, setTotalVoucher] = useState(0);
    const [totalExpense, setTotalExpense] = useState(0);
    const [totalLost, setTotalLost] = useState(0);
    const [totalToReceiver, setTotalToReceiver] = useState(0);

    const isadmin = isAdmin();
    const authData = getAuthData();
    
    const onInputFilterChange = (e, name) => {
        const val = (e.target && e.target.value) || (e.value) || '';
        let _filter = { ...filter };
        _filter[`${name}`] = val;

        setFilter(_filter);
    }

    const listDrivers = () => {
        api().get('/driver/list').then(response => {
            if(response.status === 200 && response.data.result){
                setDrivers(response.data.data);
            }
        });
    }

    const listTrucks = () => {
        api().get('truck/list').then(response => {
            if(response.status === 200 && response.data.result){
                setTrucks(response.data.data.map(truck => {
                    truck['plate'] = truck['plate'].toUpperCase();
                    return truck;
                }));
            }
        });
    }

    const listTravels = () => {
        setLoading(true);
        var filtersRequest = {...filter};

        if(filter.startDate) {
            var date = new Date(filter.startDate)
            date.setHours(0);
            date.setMinutes(0);
            date.setSeconds(0);
            filtersRequest['startDate'] = date.getTime();
        }
        if(filter.endDate) {
            var date = new Date(filter.endDate)
            date.setHours(23);
            date.setMinutes(59);
            date.setSeconds(59);
            filtersRequest['endDate'] = date.getTime();
        }
        if(!isadmin) filtersRequest['driver'] = authData.user.identifier;

        filtersRequest['status'] = 'done';
        filtersRequest['typeDate'] = 'travel.started';

        api().post('/travel/list', filtersRequest).then(response => {
            if(response.status === 200 && response.data.result){
                var travels = response.data.data;

                var _totalFreight = 0;
                var _totalCommission = 0;
                var _totalExpense = 0;
                var _totalVoucher = 0;
                var _totalLost = 0;

                travels.forEach(travel => {
                    var amountFreight = travel.quantity_ton * travel.amount_ton;
                    var amountCommission = travel.commission_percentage * amountFreight / 100;
                
                    _totalFreight += amountFreight;
                    _totalCommission += amountCommission;
                    _totalVoucher += travel.voucher;
                    _totalExpense += travel.expense_total_amount;

                    _totalLost += amountFreight + travel.truck_voucher - travel.expense_total_amount - travel.deposit - travel.voucher;
                });

                setTotalFreight(_totalFreight);
                setTotalCommission(_totalCommission);
                setTotalExpense(_totalExpense);
                setTotalVoucher(_totalVoucher);
                setTotalLost(_totalLost);
                setTotalToReceiver(_totalCommission - _totalLost - _totalVoucher);
            }
            setLoading(false);
        });
    }

    useEffect(() => {
        listTravels();
        if(isadmin) {
            listDrivers();
            listTrucks();
        }
    }, []);
  
    return (
        <div className="grid crud-demo">
            <div className="col-12">
                <div className='card'>
                    <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center mb-6">
                        <h4 className="m-0">Resumo de Pagamentos</h4>
                    </div>
                    
                    <div className="flex flex-column sm:flex-row md:align-items-center">
                        <div className="field mt-2 lg:col-3 sm:col-3">
                            <span className="p-float-label">
                                <Calendar value={filter.startDate} style={{ width: "100%" }} onChange={(e) => onInputFilterChange(e, 'startDate')} dateFormat='dd/mm/yy' locale='pt-br' />
                                <label>Data Inicial</label>
                            </span>
                        </div>
                        <div className="field mt-2 lg:col-3 sm:col-3">
                            <span className="p-float-label">
                                <Calendar value={filter.endDate} style={{ width: "100%" }} onChange={(e) => onInputFilterChange(e, 'endDate')} dateFormat='dd/mm/yy' locale='pt-br' />
                                <label>Data Final</label>
                            </span>
                        </div>
                    
                        {isadmin ? (
                            <div className="field lg:col-3 sm:col-3 mt-2">
                                <span className="p-float-label">
                                    <Dropdown value={filter.driver} id="driverFilter" style={{ width: "100%" }} options={[{ name: "Todos", code:"all" }].concat(drivers)} onChange={(e) => onInputFilterChange(e, 'driver')} optionLabel="name" optionValue='code' placeholder="Selecione o motorista" />
                                    <label htmlFor='driverFilter'>Motorista</label>
                                </span>
                            </div>
                        ) : ''}
                        {isadmin ? (
                            <div className="field lg:col-3 sm:col-3 mt-2">
                                <span className="p-float-label">
                                    <Dropdown value={filter.truck} id="truckFilter" style={{ width: "100%" }} options={[{ plate: "Todos", code:"all" }].concat(trucks)} onChange={(e) => onInputFilterChange(e, 'truck')} optionLabel="plate" optionValue='code' placeholder="Selecione o caminhão" />
                                    <label htmlFor='truckFilter'>Caminhão</label>
                                </span>
                            </div>
                        ) : ''}
                    </div>
                    <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
                        <div className="field col">
                            <Button label="Filtrar" onClick={listTravels} style={{ float: "right" }} icon="pi pi-filter" className="p-button-info" />
                        </div>
                    </div>
                </div>
            </div>
            
           
            <div className="col-12 lg:col-6 xl:col-4">
                <div className="card mb-0">
                    <div className="flex justify-content-between mb-3">
                        <div>
                            <span className="block text-500 font-medium mb-3">Total Frete</span>
                            <div className={"text-900 font-medium " + styles.moneySize}>{formatCurrency(totalFreight, true)}</div>
                        </div>
                        <div className="flex align-items-center justify-content-center bg-green-100 border-round" style={{width: '2.5rem', height: '2.5rem'}}>
                            <i className="pi pi-money-bill text-green-500 text-xl"/>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-12 lg:col-6 xl:col-4">
                <div className="card mb-0">
                    <div className="flex justify-content-between mb-3">
                        <div>
                            <span className="block text-500 font-medium mb-3">Total Comissão</span>
                            <div className={"text-900 font-medium " + styles.moneySize}>{formatCurrency(totalCommission, true)}</div>
                        </div>
                        <div className="flex align-items-center justify-content-center bg-pink-100 border-round" style={{width: '2.5rem', height: '2.5rem'}}>
                            <i className="pi pi-money-bill text-pink-500 text-xl"/>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-12 lg:col-6 xl:col-4">
                <div className="card mb-0">
                    <div className="flex justify-content-between mb-3">
                        <div>
                            <span className="block text-500 font-medium mb-3">Total Vale</span>
                            <div className={"text-900 font-medium " + styles.moneySize}>{formatCurrency(totalVoucher, true)}</div>
                        </div>
                        <div className="flex align-items-center justify-content-center bg-yellow-100 border-round" style={{width: '2.5rem', height: '2.5rem'}}>
                            <i className="pi pi-money-bill text-yellow-500 text-xl"/>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-12 lg:col-6 xl:col-4">
                <div className="card mb-0">
                    <div className="flex justify-content-between mb-3">
                        <div>
                            <span className="block text-500 font-medium mb-3">Total Não Declarado</span>
                            <div className={"text-900 font-medium " + styles.moneySize}><span style={{ color: totalLost >= 0 ? '#c33440' : '#3ed266' }}>{formatCurrency(totalLost < 0 ? -1 * totalLost : totalLost, true)}</span></div>
                        </div>
                        <div className="flex align-items-center justify-content-center bg-orange-100 border-round" style={{width: '2.5rem', height: '2.5rem'}}>
                            <i className="pi pi-money-bill text-orange-500 text-xl"/>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-12 lg:col-6 xl:col-4">
                <div className="card mb-0">
                    <div className="flex justify-content-between mb-3">
                        <div>
                            <span className="block text-500 font-medium mb-3">Total a Receber</span>
                            <div className={"text-900 font-medium " + styles.moneySize}><span style={{ color: (totalToReceiver >= 0 ? '#3ed266' : '#c33440') }}>{formatCurrency(totalToReceiver, true)}</span></div>
                        </div>
                        <div className="flex align-items-center justify-content-center bg-blue-100 border-round" style={{width: '2.5rem', height: '2.5rem'}}>
                            <i className="pi pi-money-bill text-blue-500 text-xl"/>
                        </div>
                    </div>
                </div>
            </div>
                
        </div>
    );
}